var map = {
	"./CONVOCATORIA_PUBLICA_TDE.jpeg": "Hx50",
	"./RPA-C-01-20.jpg": "3THa",
	"./RPA-C-01-21_5.jpeg": "gnDS",
	"./RPA-C-01-21_6.jpeg": "I0TK",
	"./aranceles-minimos-rpa.jpeg": "ciH+",
	"./aviso_TDE.png": "knyF",
	"./background.png": "cf+J",
	"./capacitacion.png": "AVRQ",
	"./ciudadania_digital.jpg": "/SEr",
	"./comunicadRpa_AGETIC.jpg": "TdGL",
	"./comunicadoSuspencionServiciosCI.jpg": "tbpb",
	"./comunicado_corte_servicios.jpg": "VcYd",
	"./comunicado_renovacion.jpeg": "HERk",
	"./comunidadoCorteServiciosAGETIC.jpg": "hLDi",
	"./comunidado_RPA.jpg": "08QF",
	"./comunidado_SITREA.png": "4kBa",
	"./convocatoriaONU_PRC0034051.jpg": "MgDU",
	"./convocatoriaONU_UNDP-BOL-00144-2.jpg": "f8Xv",
	"./convocatoriaTEA-bicentenario_color.jpg": "i5w1",
	"./curso_garantias.png": "P1LG",
	"./curso_transparencia.png": "s0hj",
	"./documentoPDF.png": "bJCx",
	"./error_animation.webm": "wVAw",
	"./fallecido.png": "ZmUu",
	"./fiscalia_general.png": "9KGP",
	"./fiscaliageneraldelestado.png": "kAnq",
	"./gacetaboficia.png": "LZQy",
	"./habilitados_exámenes_orales.png": "6UbJ",
	"./ley.png": "Z4VU",
	"./linea_800.png": "0KcV",
	"./lista-aprobados-TDE-1.jpg": "HjB/",
	"./lista-aprobados-TDE-2.jpg": "gsuN",
	"./logo-app-movil.png": "9CrF",
	"./logo-aula-virtual.png": "rEgT",
	"./logo-notificaciones.png": "bro/",
	"./logo-oficina-virtual.png": "aO0j",
	"./logo-vertical-ministerio-justicia.jpeg": "d2oX",
	"./logo-vertical-minjus-2021.jpg": "qX30",
	"./logo-vertical-minjus-2021.png": "zGBh",
	"./logo1173.png": "DdZS",
	"./logoFinalMjti.png": "jDP2",
	"./logoMin.png": "XCfP",
	"./logo_oficial_ministerio_justicia_1024.png": "FtcC",
	"./logorpa.PNG": "+QSB",
	"./magistratura.png": "mppL",
	"./registro.png": "ixqg",
	"./registro_abogado.jpg": "jX8T",
	"./rpa.png": "AHqT",
	"./rpaBlanco.jpg": "wtEP",
	"./rpaOpacidad.png": "K5Ja",
	"./rpablanco.png": "2IrF",
	"./ruana.png": "Pyh2",
	"./sinFoto.png": "WbwB",
	"./sociedad_civil.jpg": "CgmV",
	"./success_animation.webm": "E6I4",
	"./tribunal-constitucional.png": "SH5Z",
	"./tribunalsupremojusticia.png": "sm7g",
	"./whatsapp-logo.png": "Pxkn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 9